import React from 'react';
import PropTypes from 'prop-types';
import DropdownCycleFilter from 'components/common/DropdownCycleFilter';
import TYPE_NAMES from 'constants/typeNames';

const MemberFilter = ({ handleChange, typeName, group }) => {
  if (typeName !== TYPE_NAMES.TRANSACTION_PURPOSE) return null;

  return (
    <DropdownCycleFilter
      handleChange={(e, { cycle_id }) =>
        handleChange(e, { name: 'cycle_id', value: cycle_id })
      }
      label="Cycle"
      name="cycle_id"
      group={group}
    />
  );
};

MemberFilter.defaultProps = {
  group: {},
};

MemberFilter.propTypes = {
  handleChange: PropTypes.func.isRequired,
  typeName: PropTypes.string.isRequired,
  group: PropTypes.instanceOf(Object),
};

export default MemberFilter;
